"use client";

import { useTranslation } from "react-i18next";
import { useRouter, usePathname } from "next/navigation";
import PersonCallIcon from "@/common/PersonCallIcon";

const FloatingBar = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const pathname = usePathname();

  if (pathname === "/contact") return null;

  return (
    <div className="fixed w-full section-shell z-999 bottom-0 right-0 bg-gray-50/90 py-2! border-t border-gray-200">
      <div className="w-full max-w-[1920px] mx-auto flex justify-center md:justify-between items-center">
        <h3 className="flex-3 text-gray-800 text-[clamp(1rem,2vw,1.25rem)] font-bold leading-6 md:leading-7">
          {t("CONTACT_SECTION_TITLE")}
        </h3>

        <button
          onClick={() => router.push("/contact")}
          className="h-full bg-white text-blue-500 hover:bg-blue-500 hover:text-white px-4 md:px-8 py-2 border-2 border-blue-500 rounded-full text-base font-extrabold flex items-center gap-2"
        >
          <PersonCallIcon className="w-[24px] md:w-[28px] h-[24px] md:h-[28px]" />
          <span>{t("CONTACT_BUTTON")}</span>
        </button>
      </div>
    </div>
  );
};

export default FloatingBar;
